module.exports = __webpack_public_path__ + "img/nouSomni1.400e4533.jpg";